import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM394 432c3.3 0 6-2.7 6-6v-340c0-3.3-2.7-6-6-6h-340c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/square.js
// module id = 1817
// module chunks = 0